import React, { useState, useEffect } from "react";
import HeadingBanner from "../components/HeadingBanner";
import Login from "../components/Login";
import { Container, Row } from "react-bootstrap";
import OrientationPrompt from "../components/OrientationPrompt";

function App(props) {
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  return (
    <Container fluid className="vh-100 d-flex flex-column">
      <HeadingBanner
        isLoggedIn={false}
        cloud={true}
        name={"Assessing Letter & Phonemic Awareness Class Assistant"}
      />
      <Row className="h-100">
        <Login />
      </Row>
      {isPortrait && <OrientationPrompt />}
    </Container>
  );
}

export default App;
